interface IPageHeaderInfoBannerCookieData {
  closed: boolean;
  id: string;
}

const usePageHeader = () => {
  const setPageHeaderInfoBannerCookie = (name: string, value: IPageHeaderInfoBannerCookieData, days: number): void => {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    const cookieValue = encodeURIComponent(JSON.stringify(value)) + `; expires=${expires.toUTCString()}; path=/`;
    document.cookie = `${name}=${cookieValue}`;
  };

  const initPageHeaderInfoBanner = () => {
    document.querySelectorAll('.page-header__info-banner').forEach((bannerElement) => {
      const banner = bannerElement as HTMLElement;
      const closeButton = banner.querySelector('.page-header__info-banner-close-button') as HTMLButtonElement | null;

      if (!closeButton) {
        return;
      }

      closeButton.addEventListener('click', () => {
        banner.classList.add('page-header__info-banner--hidden');

        const id = banner.dataset.bannerId;
        const siteName = banner.dataset.site;
        if (!id || !siteName) {
          return;
        }

        const cookieData: IPageHeaderInfoBannerCookieData = {
          closed: true,
          id,
        };

        setPageHeaderInfoBannerCookie(`${siteName}_visit_today_info_banner`, cookieData, 365);
      });
    });
  };

  initPageHeaderInfoBanner();

  // Play/pause video on page header
  const toggleVideo = async (pageHeader: HTMLElement, button: HTMLButtonElement) => {
    const video = pageHeader?.querySelector('.page-header__video') as HTMLVideoElement;

    if (video.paused) {
      await video.play();
      button.classList.add('round-button--pause');
      button.classList.remove('round-button--play');
      button.setAttribute('aria-label', button.dataset.pauseText || '');
    } else {
      video.pause();
      button.classList.remove('round-button--pause');
      button.classList.add('round-button--play');
      button.setAttribute('aria-label', button.dataset.playText || '');
    }
  };

  if (!document.querySelector('.page-header video')) {
    return;
  }

  // Add event listeners to all page headers videos
  document.querySelectorAll('.page-header').forEach((pageHeader) => {
    const button = pageHeader.querySelector('.page-header__video-button') as HTMLButtonElement;
    const mediaContainer = pageHeader.querySelector('.page-header__media-container--video') as HTMLElement;
    
    if (!button || !mediaContainer) {
      return;
    }

    // Play/pause video on page header video click
    mediaContainer.addEventListener('click', async () => {
      await toggleVideo(pageHeader as HTMLElement, button);
    });

    // Play/pause video on button click
    button.addEventListener('click', async (event) => {
      event.stopPropagation();
      await toggleVideo(pageHeader as HTMLElement, button);
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    usePageHeader();
  });
} else {
  usePageHeader();
}
